/* import __COLOCATED_TEMPLATE__ from './recent-activities-table.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { select } from '@banking/ui/services/reporter';
import { inject as service } from '@ember/service';
import { recentActivities, openBundleAction, openBladeAction, removeBladeAction, updateOwnersAndSetDateRangeAction } from '@banking/ui/workflows/unified-activity/unified-activity';
import { action } from '@ember/object';
let RecentActivitiesTable = (_dec = select(state => state.loading), _dec2 = select(state => state.hasError), _dec3 = select(recentActivities), _dec4 = select(state => state.isBladeOpen), _class = class RecentActivitiesTable extends Component {
  constructor(owner, args) {
    super(owner, args);
    // Date Range must search all-time, because the recent activity component
    // would be empty otherwise when a new year begins
    _initializerDefineProperty(this, "reporter", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _defineProperty(this, "removeBladeAction", void 0);
    _initializerDefineProperty(this, "loading", _descriptor3, this);
    _initializerDefineProperty(this, "hasError", _descriptor4, this);
    _initializerDefineProperty(this, "recentActivities", _descriptor5, this);
    _initializerDefineProperty(this, "isBladeOpen", _descriptor6, this);
    this.reporter.emit(updateOwnersAndSetDateRangeAction(this.args.unitToken, undefined, undefined));
    this.removeBladeAction = removeBladeAction();
  }
  onActivitySelect(activity, event) {
    event.target.deselect();
    if (activity.isBundle) {
      this.reporter.emit(removeBladeAction());
      // NOTE(trevorfrese) opens the Banking activity page, with a bundle expanded
      this.reporter.emit(openBundleAction(activity.id));
      this.router.transitionTo('banking.activity', {
        queryParams: {
          unitToken: this.args.unitToken
        }
      });
    } else {
      // NOTE(trevorfrese) opens the Banking activity detail blade for an id
      return this.reporter.emit(openBladeAction(activity.id));
    }
  }
  viewAllActivity() {
    this.router.transitionTo('banking.activity', {
      queryParams: {
        unitToken: this.args.unitToken
      }
    });
  }
  handleViewInTransaction(action, unitToken) {
    return this.router.transitionTo(action.route, {
      queryParams: {
        ...action?.params,
        subunitToken: unitToken
      }
    });
  }
  handleGoToActivityShow(action) {
    return this.reporter.emit(openBladeAction(action.id));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "reporter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "loading", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hasError", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "recentActivities", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isBladeOpen", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onActivitySelect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onActivitySelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "viewAllActivity", [action], Object.getOwnPropertyDescriptor(_class.prototype, "viewAllActivity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleViewInTransaction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleViewInTransaction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleGoToActivityShow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleGoToActivityShow"), _class.prototype), _class);
export { RecentActivitiesTable as default };